import { render, staticRenderFns } from "./aiKnowledge.vue?vue&type=template&id=0b88c6b9&scoped=true"
import script from "./aiKnowledge.vue?vue&type=script&lang=js"
export * from "./aiKnowledge.vue?vue&type=script&lang=js"
import style0 from "./aiKnowledge.vue?vue&type=style&index=0&id=0b88c6b9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b88c6b9",
  null
  
)

export default component.exports